import {setHiddenFieldValues, validateAddressWithGeocoder} from './address-autocomplete-validation'

function initAutocomplete() {

	const addressAutocompleteInputFields = document.querySelectorAll(".js-address-autocomplete"),
		autocompleteOptions = {
			types: [
				'route',
				'street_number',
				'postal_code',
				'locality'
			],
			componentRestrictions: {country: "de"}
		};

	if (addressAutocompleteInputFields) {
		addressAutocompleteInputFields.forEach(addressAutocompleteInputField => {

			const autocomplete = new google.maps.places.Autocomplete(addressAutocompleteInputField, autocompleteOptions);

			autocomplete.addListener("place_changed", () => {
				const placeObject = autocomplete.getPlace();

				setHiddenFieldValues(placeObject, addressAutocompleteInputField);
			});

			addressAutocompleteInputField.addEventListener('keydown', event => {

				if (event.code === 'Enter') {
					event.stopPropagation();
					event.preventDefault();
					validateAddressWithGeocoder(addressAutocompleteInputField);
				}

			});

			addressAutocompleteInputField.addEventListener('blur', () => {
				setTimeout(function () {
					validateAddressWithGeocoder(addressAutocompleteInputField);
				}, 500);
			});

		});
	}

}

window.addEventListener('DOMContentLoaded', () => {
	const elementAdressAutocompleteField = document.querySelector('.js-address-autocomplete');

	if (elementAdressAutocompleteField) {
		const script = document.createElement('script');

		script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCaEr74Ukg5yo_WhnraQ6kXqNrLxhwn2i4&callback=initAutocomplete&libraries=geocoding,places';
		script.async = true;
		script.defer = true;

		document.head.appendChild(script);
	}
});

window.initAutocomplete = initAutocomplete;
